var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7410_2214",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7410_2214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 18C3.76875 18 3.35677 17.8321 3.01406 17.4964C2.67135 17.1607 2.5 16.7571 2.5 16.2857V7.71429C2.5 7.24286 2.67135 6.83929 3.01406 6.50357C3.35677 6.16786 3.76875 6 4.25 6H5.125V4.28571C5.125 3.1 5.55156 2.08929 6.40469 1.25357C7.25781 0.417857 8.28958 0 9.5 0C10.7104 0 11.7422 0.417857 12.5953 1.25357C13.4484 2.08929 13.875 3.1 13.875 4.28571V6H14.75C15.2312 6 15.6432 6.16786 15.9859 6.50357C16.3286 6.83929 16.5 7.24286 16.5 7.71429V16.2857C16.5 16.7571 16.3286 17.1607 15.9859 17.4964C15.6432 17.8321 15.2312 18 14.75 18H4.25ZM4.25 16.2857H14.75V7.71429H4.25V16.2857ZM6.875 6H12.125V4.28571C12.125 3.57143 11.8698 2.96429 11.3594 2.46429C10.849 1.96429 10.2292 1.71429 9.5 1.71429C8.77083 1.71429 8.15104 1.96429 7.64062 2.46429C7.13021 2.96429 6.875 3.57143 6.875 4.28571V6Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.3eea06e5b5ca1f5aac6355f0d3ef6144.svg";
export { ForwardRef as ReactComponent };